import { createSelector } from "reselect";

import { makeSelectAppKeys, makeSelectAppLoggedIn, makeSelectRoutePathname } from "../../app/appSelectors";
import { isClientMobile } from "../../components/ClientInfo/ClientInfo";
import { PAGES_ZENDESK_FIXED_BUTTON_HIDDEN } from "./zendesk-constants";

export const getZendeskSnippetKey =
    createSelector(makeSelectAppKeys(), appKeys => appKeys.zendeskSnippetKey || '');

export const getIsZendeskFixedButtonVisible =
    createSelector([makeSelectRoutePathname(), makeSelectAppLoggedIn()], (pathname, loggedIn) =>
        !PAGES_ZENDESK_FIXED_BUTTON_HIDDEN.includes(pathname) && (!isClientMobile || !loggedIn));
